/**
 * Product Variant Navigation - Section Rendering API
 * Allows navigating between product variants without page reload
 */

function initializeSizeValidation() {
  if (typeof jQuery === 'undefined') return;
  
  const $ = jQuery;
  
  if ($('fieldset').length > 1) {
    $('fieldset[data-option-name="width"]').find('.product-form__controls-group').find('input[type="radio"]:not(.disabled):first').prop("checked", true).trigger('click');
    $('.product-form__submit[name="add"]').addClass('size_disabled');
    updateButtonText();

    $('.product-form__controls-group[data-option-name="size"]').find('[type="radio"]').off('click').on('click', function(){
      $(this).closest('.product__info-container').find('.product-form').find('button[name="add"]').removeClass('size_disabled');
      $('.product-form__error-message-wrapper').attr('hidden', true);
      $('.product-form__error-message').text('');
      updateButtonText();
    });

    $('.size_disabled').off('click').on('click', function(e) {
      if ($(this).hasClass('size_disabled')) {
        e.preventDefault();
        var $size_option = $(this).closest('.product__info-wrapper').find('.product-form__input--radios').find('.product-form__controls-group[data-option-name="size"]').find('[type="radio"]').is(':checked');
        if (!$size_option) {
          $('.product-form__error-message').text('Please select a size');
          $('.product-form__error-message-wrapper').removeAttr('hidden');
        } else {
          $(this).removeClass('size_disabled');
          $('.product-form__error-message-wrapper').attr('hidden', true);
          $('.product-form__error-message').text('');
        }
        return false;
      } else {
        return true;
      }
    });

    function checkWidth() {
      var $selWidth = $('fieldset[data-option-name="width"]').find('.product-form__controls-group').find('input[type="radio"]:checked').val();
      $('select[name="currid"]').find('option').each(function() {
        var $this = $(this);
        var $width = $this.data('option-width');
        var $size = $this.data('option-size');
        var $avail = $this.text().split("--")[1];

        if ($selWidth == $width && $avail == 'avail') {
          $('.product-form__input--radios[data-option-name="size"] > .product-form__controls-group > input[type="radio"][value="' + $size + '"]').removeClass('disabled');
        }
      });
    }
    checkWidth();

    $('.product-form__controls-group[data-option-name="width"]').find('[type="radio"]').off('click').on('click', function(){
      $('.product-form__controls-group[data-option-name="size"] input[type="radio"]').addClass('disabled');
      checkWidth();

      var $currSize = $('.product-form__controls-group[data-option-name="size"] input[type="radio"]:checked').val();
      $('.product-form__controls-group[data-option-name="size"] input[type="radio"][value="' + $currSize + '"]').removeAttr('checked');
      $('.product-form__controls-group[data-option-name="size"] input[type="radio"][value="' + $currSize + '"]').prop('checked', false);
      $('button[name="add"]').removeAttr('disabled').addClass('size_disabled');
      updateButtonText();
    });
  }
}

function updateButtonText() {
  if (typeof jQuery === 'undefined') return;
  
  const $ = jQuery;
  const button = $('button[name="add"]');
  const defaultText = button.find('.button-text-default');
  const selectSizeText = button.find('.button-text-select-size');
  
  if (button.hasClass('size_disabled')) {
    defaultText.hide();
    selectSizeText.show();
  } else {
    defaultText.show();
    selectSizeText.hide();
  }
}

function initializeVariantFormSync() {
  document.querySelectorAll('variant-radios, variant-selects').forEach((picker) => {
    if (picker.dataset.variantSyncInitialized === 'true') return;

    const variantsScript = picker.querySelector('script[type="application/json"]');
    if (!variantsScript) return;

    let variants = [];
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (error) {
      console.error('Unable to parse product variants:', error);
      return;
    }

    const syncSelectedVariant = () => {
      const selectedOptions = Array.from(picker.querySelectorAll('fieldset')).map((fieldset) => {
        const select = fieldset.querySelector('select');
        if (select) return select.value;

        const checkedRadio = fieldset.querySelector('input[type="radio"]:checked');
        return checkedRadio ? checkedRadio.value : null;
      });

      if (selectedOptions.some((option) => option === null)) return;

      const selectedVariant = variants.find((variant) => {
        return variant.options.every((option, index) => option === selectedOptions[index]);
      });

      if (!selectedVariant) return;

      const productInfo = picker.closest('.product__info-container') || document;
      const form = productInfo.querySelector('form[data-type="add-to-cart-form"]');
      const idInput = form ? form.querySelector('[name="id"]') : null;
      if (!idInput) return;

      idInput.value = selectedVariant.id;

      const productSelect = productInfo.querySelector('select[name="currid"]');
      if (productSelect) {
        productSelect.value = selectedVariant.id;
      }
    };

    picker.addEventListener('change', syncSelectedVariant);
    picker.dataset.variantSyncInitialized = 'true';
    syncSelectedVariant();
  });
}

function initializeAccordions() {
  if (typeof jQuery === 'undefined') return;
  
  const $ = jQuery;
  
  // Remove any existing click handlers to prevent duplicates
  $(".product-about__accordion-title").off('click');
  
  // Re-attach accordion click handlers
  $(".product-about__accordion-title").on('click', function () {
    if (!$(this).hasClass("active")) {
      $(".product-about__accordion-title.active").removeClass("active");
      $(this).addClass("active");
      $(".product-about__accordion-description").stop().slideUp(300);
      $(this)
        .siblings(".product-about__accordion-description")
        .stop()
        .slideDown(300);
    } else {
      $(this).removeClass("active");
      $(this).siblings(".product-about__accordion-description").stop().slideUp(300);
    }
  });
}

function initializeCopyButtons() {
  // Reinitialize copy button listeners
  const copyLinks = document.querySelectorAll('.copy-btn, .copy-link-btn');
  
  copyLinks.forEach(copyLink => {
    // Remove existing listeners to prevent duplicates
    const newCopyLink = copyLink.cloneNode(true);
    copyLink.parentNode.replaceChild(newCopyLink, copyLink);
    
    // Add the click listener
    newCopyLink.addEventListener('click', function(evt) {
      evt.preventDefault();
      const button = evt.currentTarget;
      
      navigator.clipboard.writeText(window.location.href).then(() => {
        const originalHTML = button.innerHTML;
        const originalLabel = button.getAttribute('aria-label');
        
        const checkIcon = `
          <svg width="21" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 100%; height: 100%;">
            <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        `;
        
        button.innerHTML = checkIcon;
        button.setAttribute('aria-label', 'Link copied!');
        button.style.color = '#021769';
        
        setTimeout(() => {
          button.innerHTML = originalHTML;
          if (originalLabel) {
            button.setAttribute('aria-label', originalLabel);
          }
          button.style.color = '';
        }, 2000);
      }).catch(err => {
        console.error('Failed to copy link:', err);
      });
    });
  });
}

function attachProductClickListener() {
  const products = document.querySelector(".group-products");
  if (products) {
    products.addEventListener("click", handleClick);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSizeValidation);
  } else {
    initializeSizeValidation();
  }

  initializeVariantFormSync();
}

function handleClick(event) {
  const anchor = event.target.closest("a[data-url]");
  if (!anchor) return;
  event.preventDefault();

  const url = anchor.getAttribute("data-url");
  const section = document.querySelector('[id^="MainProduct-"]');
  
  if (!section) {
    console.error("No MainProduct element found");
    window.location.href = url;
    return;
  }

  // Show loading state
  section.style.opacity = "0.6";
  section.style.pointerEvents = "none";
  
  fetch(url)
    .then(response => response.text())
    .then(resText => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(resText, "text/html");
      const newMainContent = doc.querySelector('[id^="MainProduct-"]');
      
      if (newMainContent) {
        // Replace the content
        section.innerHTML = newMainContent.innerHTML;
        
        // Update the URL without reload
        history.pushState(null, '', url);
        
        // Update the page title
        const newTitle = doc.querySelector('title');
        if (newTitle) {
          document.title = newTitle.innerText;
        }
        
        // Reset opacity
        section.style.opacity = "1";
        section.style.pointerEvents = "auto";
        
        // Reattach the click listener after updating the content
        attachProductClickListener();
        
        // Reinitialize size validation
        initializeSizeValidation();
        initializeVariantFormSync();
        
        // Reinitialize accordions (description, reviews, etc.)
        initializeAccordions();
        
        // Reinitialize copy buttons
        initializeCopyButtons();
        
        // Reinitialize any Shopify scripts that might be needed
        if (window.Shopify && window.Shopify.PaymentButton) {
          window.Shopify.PaymentButton.init();
        }
        
        // Dispatch event for other scripts that might need to reinitialize
        document.dispatchEvent(new CustomEvent('product-variant-changed', { 
          detail: { url: url } 
        }));
        
        // Scroll to top of product section
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        
      } else {
        console.error("No MainProduct element found in the fetched HTML.");
        window.location.href = url;
      }
    })
    .catch(error => {
      console.error("Error fetching new content:", error);
      // Fallback: Navigate to the URL if the fetch fails
      window.location.href = url;
    });
}

// Initial attachment when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', attachProductClickListener);
} else {
  attachProductClickListener();
}

